import type { SurgicalGuideCaseData } from '@/stores/surgicalGuide/surgicalGuide.types';

/**
 * Validates that a CR number contains only numeric characters.
 * Empty string and null/undefined are considered valid.
 */
export function isCRNumberValid(value: string | null | undefined): boolean {
    if (value == null || value === '') {
        return true;
    }
    return /^\d+$/.test(value);
}

/**
 * Field validators — return true when the input is valid, false otherwise.
 * Mirrors the pattern in views/preferences/preferencesValidation.ts.
 */
export const validators: { [key: string]: (data: SurgicalGuideCaseData) => boolean } = {
    crNumber: ({ crNumber }) => isCRNumberValid(crNumber),
};

export const isValid = (data: SurgicalGuideCaseData): boolean =>
    Object.values(validators).every((validator) => validator(data));